import { render, staticRenderFns } from "./MoreInfoModal.vue?vue&type=template&id=1bb6475b&scoped=true&"
import script from "./MoreInfoModal.vue?vue&type=script&lang=ts&"
export * from "./MoreInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./MoreInfoModal.vue?vue&type=style&index=0&id=1bb6475b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6475b",
  null
  
)

export default component.exports